/* eslint-disable camelcase */

export const isValidToken = ({
  email,
  account_id,
  invitation_id
}: { email: string, account_id: string, invitation_id: string }) => email && account_id && invitation_id
